"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCollector = void 0;
class EventCollector {
    constructor() {
        this.eventBus = null;
        this.getEventBus = () => {
            return this.eventBus;
        };
    }
}
exports.EventCollector = EventCollector;
//# sourceMappingURL=types.js.map